import React, {FC} from 'react';

import {Icon, Loader, Text} from '@gravity-ui/uikit';
import i18n from 'ui/i18n';

import VisuallyHidden from '../VisuallyHidden';

import {cnIntegrationItem} from './IntegrationItem.constants';
import {IntegrationItemProps} from './IntegrationItem.types';
import {
    getIntegrationTypeIcon,
    getIntegrationTypeTitle,
    renderIntegrationType,
} from './IntegrationItem.utils';

import './IntegrationItem.scss';

const IntegrationItem: FC<IntegrationItemProps> = ({data, type}) => {
    const failedCount = data.failed.length;
    const succeedCount = data.succeed.length;

    return (
        <div className={cnIntegrationItem()}>
            <div className={cnIntegrationItem('Header')}>
                <h3 className={cnIntegrationItem('Title')}>
                    <Icon data={getIntegrationTypeIcon(type)} aria-hidden="true" />
                    <Text variant="subheader-3" as="div">
                        {i18n('success-page', getIntegrationTypeTitle(type))}
                    </Text>
                </h3>

                {data.isSomePending && (
                    <>
                        <div aria-hidden="true">
                            <Loader size="m" />
                        </div>
                        <VisuallyHidden>{i18n('success-page', 'sr-loading')}</VisuallyHidden>
                    </>
                )}
            </div>

            <div role="status" aria-live="polite">
                {!data.isSomePending && (
                    <div className={cnIntegrationItem('Content')}>
                        {Boolean(failedCount) && (
                            <div className={cnIntegrationItem('Block')}>
                                <Text variant="body-2" color="danger" as="div">
                                    {i18n('success-page', 'integrations-errors', {
                                        count: failedCount,
                                        failedCount,
                                    })}
                                </Text>
                                <div className={cnIntegrationItem('Block')}>
                                    {data.failed.map(({id, message}) => (
                                        <Text key={id} variant="body-2">
                                            {message}
                                        </Text>
                                    ))}
                                </div>
                            </div>
                        )}

                        {Boolean(succeedCount) && (
                            <div className={cnIntegrationItem('Block')}>
                                {renderIntegrationType(type, data.succeed)}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default IntegrationItem;
